/** @jsx jsx */
import { CheckCircleFillIcon, CloseCircleFillIcon, Loader } from "@eworkit/iris";
import { motion, TargetAndTransition } from "framer-motion";
import { FC } from "react";
import { jsx, useThemeUI } from "theme-ui";

import { TimeReportEditItemStatus } from "../../edit/_components/timeReportEditReducer";

interface TimeReportCalendarPayCodeRowCellStatusProps {
  status?: TimeReportEditItemStatus;
}

export const TimeReportCalendarPayCodeRowCellStatus: FC<TimeReportCalendarPayCodeRowCellStatusProps> = ({
  status = "idle",
}) => {
  const { theme } = useThemeUI();

  if (status === "idle") {
    return null;
  }

  let animate: TargetAndTransition = {
    opacity: 0,
  };

  switch (status) {
    case "working":
      animate = { opacity: 1, backgroundColor: theme.colors?.y50 as string, color: theme.colors?.n1000 as string };
      break;
    case "success":
      animate = { opacity: 1, backgroundColor: theme.colors?.g50 as string, color: theme.colors?.g400 as string };
      break;
    case "error":
      animate = { opacity: 1, backgroundColor: theme.colors?.r50 as string, color: theme.colors?.r400 as string };
      break;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={animate}
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {status === "working" && <Loader size="md" />}
      {status === "success" && <CheckCircleFillIcon size="md" />}
      {status === "error" && <CloseCircleFillIcon size="md" />}
    </motion.div>
  );
};
